import "jquery-modal/jquery.modal.min.css";
import "./shoptet.less";
import "./colors.less";
import "./ladzo.less";
import "./fonty.css";

import * as produkty from "./incl/produkty.js";
import * as uvod from "./page/uvod.js";
import * as detail from "./page/detail.js";
import * as kosik from "./page/kosik.js";
import * as kategorie from "./page/kategorie.js";
import * as iframe from "./incl/iframe.js";
import * as obsah from "./incl/obsah.js";

if (process.env.NODE_ENV == "development") {
  require("./Recomp_css/styles_part_1_recomp_V2.css");
  require("./Recomp_css/styles_part_1_recomp.css");
  //import "./Recomp_css/styles_part_1_recomp_V3_1.css";
  require("./Recomp_css/styles_part_1_recomp_V3_3.css");
  require("./Recomp_css/zapati.css");
}

//--povoli konzoli
var Url = new URL(window.location.href);
if (process.env.NODE_ENV == "development" || Url.searchParams.has("debug")) {
  Lc.zobraz({ version: "4.0.4", appName: "Recomp" });
}

$(document).ready(function() {
  // console.log('recomp ready 2.0231');

  obsah.vytvorBublinyModal();

  //skryti kategorie v menu
  $('.navigation-in li a[href="/extras/"]')
    .closest("li")
    .hide();
  $('div.menu-helper ul li a[href="/extras/"]')
    .closest("li")
    .hide();
  /*
    const fetch = require("node-fetch");
  fetch("/action/Iplatba/GetMinPayment/")
    .then(res => res.text())
    .then(body => console.log(body));
*/
  //---uprav produkty
  produkty.upravProdukty();
  if (window.location.pathname == "/" && $("body").hasClass("type-index")) {
    //uvod.js
    uvod.upravStranku();
  } else if ($("body").hasClass("type-product")) {
    //detail.js
    detail.upravDeteailProduktu();
  } else if (window.location.pathname == "/kosik/") {
    //--kosik.js
    kosik.kosik_vypisKosiku();
  } else if (window.location.pathname == "/objednavka/krok-1/") {
    //--kosik.js
    kosik.kosik_krok1();
  } else if ($("body").hasClass("type-category")) {
    //kategorie.js
    kategorie.kat_upravStrankuKategorie();
  } else if (window.location.pathname == "/registrace/") {
    if (Url.searchParams.has("iframe")) {
      iframe.upravIframe();
    }
  } else if (
    window.location.pathname == "/reklamacni-formular/" ||
    window.location.pathname == "/vykupni-formular/" ||
    window.location.pathname == "/vykup/"
  ) {
    $("article header").hide();
    $("#ifrForm").load(function() {
      Lc.log("load the iframe");
      $(this).iFrameResize();
    });
  }

  /*
 else if ($("body").hasClass("in-ext")) {
    //clanek-bubliny.js
    // upravClanekBubliny();
  }else if ($("body").hasClass("type-category")) {
    //kategorie.js
    kat_upravStrankuKategorie();
  } else if (
    window.location.pathname == "/reklamacni-formular/" ||
    window.location.pathname == "/vykupni-formular/" ||
    window.location.pathname == "/vykup/"
  ) {
    $("article header").hide();
    $("#ifrForm").load(function() {
      console.log("load the iframe");
      $(this).iFrameResize();
    });
  }

*/
});
